import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MtnCoreModule } from "../core/mtn-core.module";
import { MapSearchComponent } from "./map-search.component";
import { MtnMapModule } from "../map/mtn-map.module";
import { StoreSpotlightPanelComponent } from "./spotlight-panel/store-spotlight-panel/store-spotlight-panel.component";
import { MtnRoutingModule } from "../core/modules/mtn-routing.module";
import { MultiSelectSpotlightPanelComponent } from "./spotlight-panel/multi-select-spotlight-panel/multi-select-spotlight-panel.component";
import { StoreFeatureCardComponent } from "./spotlight-panel/multi-select-spotlight-panel/store-feature-card/store-feature-card.component";
import { TranslateModule } from "@ngx-translate/core";
import { AssetReviewTryNowBoxComponent } from "./spotlight-panel/asset-review-try-now-box/asset-review-try-now-box.component";
import { Frame67Component } from "./spotlight-panel/asset-review/frame-67/frame-67.component";
import { SalesPerformanceCardComponent } from "./spotlight-panel/sales-performance-card/sales-performance-card.component";
import { AssetReviewFullPageComponent } from "./spotlight-panel/asset-review/asset-review-full-page/asset-review-full-page.component";
import { OverallGradeBreakdownHeaderComponent } from "./spotlight-panel/overall-grade-breakdown-header/overall-grade-breakdown-header.component";
import { StoreGradeCardComponent } from "./spotlight-panel/store-grade-card/store-grade-card.component";
import { AssetGradeCardComponent } from "./spotlight-panel/asset-grade-card/asset-grade-card.component";
import { AnalyticsPerformancePanelComponent } from "./spotlight-panel/analytics-performance-panel/analytics-performance-panel.component";
import { AnalyticsReviewFullPageComponent } from "./spotlight-panel/analytics-review-full-page/analytics-review-full-page.component";
import { OverallGradeBreakdownChartComponent } from "./spotlight-panel/analytics-performance-panel/overall-grade-breakdown-chart/overall-grade-breakdown-chart.component";
import { AnalyticsErrorStateComponent } from "./spotlight-panel/analytics-performance-panel/analytics-error-state/analytics-error-state.component";
import { AnalyticsSalesDataErrorComponent } from "./spotlight-panel/analytics-performance-panel/analytics-sales-data-error/analytics-sales-data-error.component";
import { HtmlTooltipDirective } from "./spotlight-panel/analytics-performance-panel/html-tooltip.directive";
import { OverlayModule } from "@angular/cdk/overlay";

@NgModule({
  declarations: [
    MapSearchComponent,
    StoreSpotlightPanelComponent,
    MultiSelectSpotlightPanelComponent,
    StoreFeatureCardComponent,
    SalesPerformanceCardComponent,
    AssetReviewFullPageComponent,
    AnalyticsPerformancePanelComponent,
    AnalyticsReviewFullPageComponent,
    OverallGradeBreakdownChartComponent,
    AnalyticsErrorStateComponent,
    AnalyticsSalesDataErrorComponent,
    HtmlTooltipDirective,
  ],
  imports: [
    CommonModule,
    MtnCoreModule,
    MtnMapModule,
    MtnRoutingModule,
    TranslateModule,
    OverlayModule,
    AssetReviewTryNowBoxComponent,
    Frame67Component,
    StoreGradeCardComponent,
    AssetGradeCardComponent,
    OverallGradeBreakdownHeaderComponent,
  ],
})
export class MtnMapSearchModule {}
